import { initializeApp } from "firebase/app";
import { getFirestore, initializeFirestore,CACHE_SIZE_UNLIMITED, persistentLocalCache } from "firebase/firestore";
import { getAuth, initializeAuth, indexedDBLocalPersistence } from "firebase/auth";
import { getFunctions } from "firebase/functions";

// Project imports
import { isNative } from "lib/capacitor/capacitor";
import config from "config/config";

// Initialize Firebase app
const firebaseApp = initializeApp(config.FIREBASE_API);

const firestore = isNative
  ? initializeFirestore(firebaseApp, {
      localCache: persistentLocalCache({
        cacheSizeBytes: CACHE_SIZE_UNLIMITED,
      }),
    })
  : getFirestore(firebaseApp);

// const firestore = getFirestore(firebaseApp);
const auth = isNative
  ? initializeAuth(firebaseApp, {
      persistence: indexedDBLocalPersistence,
    })
  : getAuth(firebaseApp);
// const auth = getAuth(firebaseApp);
const functions = getFunctions(firebaseApp, "europe-west3");

// Export the initialized Firebase services for use in other parts of the app
export { firebaseApp, firestore, auth, functions };